import React, { useEffect } from "react";
import { CircularProgress, Stack, Typography } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import { itsRequest } from "http/authConfig";
import PublicShell from "./PublicShell";
import { useTranslation } from "react-i18next";

type AuthRedirectPageProps = {
  mode: "login" | "register";
};

const AuthRedirectPage: React.FC<AuthRedirectPageProps> = ({ mode }) => {
  const { instance } = useMsal();
  const { t } = useTranslation();

  useEffect(() => {
    instance.loginRedirect(itsRequest);
  }, [instance]);

  return (
    <PublicShell>
      <Stack spacing={2} alignItems="center" justifyContent="center" sx={{ py: 6 }}>
        <CircularProgress color="secondary" />
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          {mode === "login" ? t("landing.authRedirect.login") : t("landing.authRedirect.register")}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {t("landing.authRedirect.helper", {
            mode: mode === "login" ? t("landing.nav.login") : t("landing.nav.register"),
          })}
        </Typography>
      </Stack>
    </PublicShell>
  );
};

export default AuthRedirectPage;
